import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Splash from "../pages/splash/page";
import Auth from "../pages/auth/page";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/product-detail/page";
import Cart from "../pages/cart/page";
import Address from "../pages/address/page";
import Quotes from "../pages/quotes/page";
import Payment from "../pages/payment/page";
import Tracking from "../pages/tracking/page";
import Rating from "../pages/rating/page";
import Orders from "../pages/orders/page";
import Wholesale from "../pages/wholesale/page";
import Profile from "../pages/profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/product/:id",
    element: <ProductDetail />,
  },
  {
    path: "/cart",
    element: <Cart />,
  },
  {
    path: "/address",
    element: <Address />,
  },
  {
    path: "/quotes",
    element: <Quotes />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/tracking",
    element: <Tracking />,
  },
  {
    path: "/rating",
    element: <Rating />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/wholesale",
    element: <Wholesale />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
